import { Injectable } from "@angular/core";
import { ConfigService, SystemUrlService } from "@xo/client-common";

@Injectable()
export class GroupUrlService extends SystemUrlService {
    //TODO remove public modifier from system
    constructor(public system: string, configService: ConfigService) {
        super(system, "Xodos", "Group", configService);
    }
}